import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12.333 11.39l4.196-4.195a.667.667 0 11.942.943l-4.195 4.195 4.195 4.196a.667.667 0 01-.942.942l-4.196-4.195-4.195 4.195a.667.667 0 01-.943-.942l4.196-4.196-4.196-4.195a.667.667 0 11.943-.943l4.195 4.196z" /></svg>);